import React from 'react';
import { RouteStop } from '../driverRoutesTypes';
import styles from './RouteStopList.module.css';

interface RouteStopListProps {
  stops: RouteStop[];
  onStopAction?: (stop: RouteStop) => void;
}

const statusBadge: Record<RouteStop['status'], string> = {
  Delivered: 'delivered',
  'In Progress': 'inProgress',
  Pending: 'pending',
};

const statusButton: Record<RouteStop['status'], { label: string; variant: string }> = {
  Delivered: { label: 'View Details', variant: 'btnNeutral' },
  'In Progress': { label: 'Start Delivery', variant: 'btnPrimary' },
  Pending: { label: 'Navigate', variant: 'btnLink' },
};

export const RouteStopList: React.FC<RouteStopListProps> = ({ stops, onStopAction }) => {
  return (
    <div className={styles.section}>
      <h4 className={styles.sectionTitle}>Route Stops</h4>
      <div className={styles.list}>
        {stops.map((stop) => (
          <div key={stop.id} className={`${styles.stop} ${styles[`stop_${statusBadge[stop.status]}`]}`}>
            <span className={`${styles.index} ${styles[`idx_${statusBadge[stop.status]}`]}`}>
              {stop.index}
            </span>
            <div className={styles.info}>
              <p className={styles.name}>{stop.name}</p>
              <p className={styles.line}>{stop.address}</p>
              <p className={styles.line}>Contact: {stop.contact}</p>
              <p className={styles.line}>Order #{stop.orderId}</p>
            </div>
            <div className={styles.right}>
              <span className={`${styles.badge} ${styles[`badge_${statusBadge[stop.status]}`]}`}>
                {stop.status}
              </span>
              <button
                type="button"
                className={`${styles.actionBtn} ${styles[statusButton[stop.status].variant]}`}
                onClick={() => onStopAction?.(stop)}
              >
                {statusButton[stop.status].label}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
